/**
 * @file コンポーネント：フル動画ページフル動画プレイヤー字幕 DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledSubtitle,
    StyledSubtitleContainer,
    StyledSubtitleText,
    StyledSubtitleTitle,
    StyledSubtitleUser,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ReactDOM
    return (
        <StyledSubtitle className={props.isShowSubtitle === false && "is-hide"}>
            {props.subtitle && (
                <StyledSubtitleContainer>
                    {/* タイトル（トピックのみ） */}
                    {props.subtitle.title && (
                        <StyledSubtitleTitle>
                            {props.subtitle.title}
                        </StyledSubtitleTitle>
                    )}
                    {/* ユーザー名（トピックのみ） */}
                    {props.subtitle.userName && (
                        <StyledSubtitleUser
                            data-user={
                                props.subtitle.userId === props.mainSurgeonId &&
                                "main"
                            }
                        >
                            {props.subtitle.userName}
                        </StyledSubtitleUser>
                    )}
                    {/* 本文 */}
                    <StyledSubtitleText
                        dangerouslySetInnerHTML={{
                            __html: props.subtitle.text,
                        }}
                        data-type={props.subtitle.title && "topic"}
                        data-user={
                            props.subtitle.userId === props.mainSurgeonId &&
                            "main"
                        }
                        ref={props.refText}
                    />
                </StyledSubtitleContainer>
            )}
        </StyledSubtitle>
    );
};
